module.exports = __webpack_public_path__ + "img/mexico867.22220cfa.jpg";